import React from 'react';
import styled, { css } from 'styled-components';
import { Clickable } from 'src/components/clickable';
import { colors, colorUtils, layout } from 'src/components/base';
import { IconChevronDown } from '@prisjakt/ui/icon/chevron-down';

export const ExpandableGroup = styled.div``;

type HeaderProps = {
  expanded: boolean;
  dark?: boolean;
};

export const Header = styled(Clickable)<HeaderProps>`
  align-items: center;
  color: ${props => props.theme.text.callToAction};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  padding: ${layout.measurements.spacing050};
  text-align: left;
  transition: background-color ${layout.animations.buttonTransition};
  width: 100%;

  ${props =>
    props.expanded &&
    css`
      box-shadow: inset 0 -2px 0 ${props.theme.lines.groupHeader};
    `};

  ${props =>
    props.dark &&
    css`
      background-color: ${colors.backgroundDarkGray};
    `};

  &.focus-visible {
    background-color: ${props =>
      colorUtils.setRgbaAlpha(props.theme.colors.maybeBlue700, '0.5')};
  }
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: ${layout.measurements.fontSizeNormal};
  padding: 0 ${layout.measurements.spacing050};
`;

type HeaderArrowProps = {
  expanded: boolean;
};

export const HeaderArrow = styled(({ expanded, ...props }) => (
  <IconChevronDown {...props} color="maybeBlue700" size={24} />
))<HeaderArrowProps>`
  transition: transform 0.15s ease-in-out;
  transform: ${props => (props.expanded ? 'scaleY(-1)' : 'none')};
`;

export const BadgeArea = styled.div`
  /* Align the badge to the right */
  margin-left: auto;
`;
